// extracted by mini-css-extract-plugin
export default {"container":"answer-row_container__9UwMS","row-field":"answer-row_row-field__aqq+Y","list-header":"answer-row_list-header__k95jt","notOffer":"answer-row_notOffer__Xe103"};